import script from "./InfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=0de305b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de305b3"]])

export default __exports__